import { CodeEditor } from '@/components/shared/code-editor'
import example from './example.json'

export function AutomationSdkNx() {
  return (
    <CodeEditor
      className="max-h-[650px]"
      tabs={[
        {
          filename: 'project.json',
          content: JSON.stringify(example, null, 2),
        },
      ]}
    />
  )
}
